module.exports = __webpack_public_path__ + "static/media/love.10366285.PNG";